import vue from "../../main";

export default class DelegationRateItem {
  constructor($groupId = null) {
    this.id = null;
    this.country_symbol = null;
    this.region = null;
    this.amount = null;
    this.hotel_limit = null;
    this.group_id = $groupId;
    this.currency = null;

    // this.defaults = {
    //     delegation_vehicle_under_900_rate: "0.5214",
    //     delegation_vehicle_above_900_rate: "0.8358",
    //     delegation_vehicle_moped_rate: "0.1383",
    //     delegation_vehicle_motorcycle_rate: "0.2302"
    // };

    // this.rules = {
    //     delegation_vehicle_under_900_rate: [
    //         v => (v != null && v.length > 0) || 'Stawka jest wymagana'
    //     ],
    //     delegation_vehicle_above_900_rate: [
    //         v => (v != null && v.length > 0) || 'Stawka jest wymagana'
    //     ],
    //     delegation_vehicle_moped_rate: [
    //         v => (v != null && v.length > 0) || 'Stawka jest wymagana'
    //     ],
    //     delegation_vehicle_motorcycle_rate: [
    //         v => (v != null && v.length > 0) || 'Stawka jest wymagana'
    //     ]
    // };
  }

  rules() {
    return {
      country_symbol: [v => (v != null && v.length > 0) || vue.$t("global.error.required")],
      region: [],
      amount: [v => (v != null && v.length > 0) || vue.$t("global.error.required")],
      hotel_limit: [v => (v != null && v.length > 0) || vue.$t("global.error.required")],
      group_id: [],
      currency: [v => (v != null && v.length > 0) || vue.$t("global.error.required")]
    };
  }

  load(id) {
    vue.axios.get("settings/delegation-rate/get-delegation-rate-item?id=" + id).then(resp => {
      this.id = id;
      this.country_symbol = resp.data.country_symbol.toString();
      this.region = resp.data.region.toString();
      this.amount = resp.data.amount.toString();
      this.hotel_limit = resp.data.hotel_limit.toString();
      this.group_id = resp.data.group_id != null ? resp.data.group_id.toString() : null;
      this.currency = resp.data.currency.toString();
    });
  }

  save() {
    return new Promise((resolve, reject) => {
      vue.axios
        .post("settings/delegation-rate/save-delegation-rate-item", this)
        .then(resp => {
          resolve(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  }
}
